import { TimeZone } from "@/store/types";

/**
 * Resolves the user-facing label for a timezone.
 * @param timeZone The timezone to resolve a label for.
 * @param isDisplayNameEnabled Whether the TimeZoneDisplayName feature is enabled.
 */
export function getTimeZoneLabel(timeZone: TimeZone | null | undefined, isDisplayNameEnabled: boolean): string {
	if (!timeZone) {
		return "";
	}

	if (isDisplayNameEnabled && timeZone.displayName) {
		return timeZone.displayName;
	}

	return timeZone.id ?? "";
}
